const skills = [
  {
    imagem: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg',
    nome:'HTML',
    texto: 'HTML é uma linguagem de marcação utilizada na construção de páginas na Web.',
  },

  {
    imagem: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg',
    nome:'CSS',
    texto: 'Cascading Style Sheets é um mecanismo para adicionar estilos a uma página web, aplicado diretamente nas tags HTML ou ficar contido dentro das tags <style>.',
  },

  {
    imagem: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg',
    nome:'JavaScript',
    texto: 'JavaScript é uma linguagem de programação interpretada estruturada, de script em alto nível com tipagem dinâmica fraca e multiparadigma.',
  },

  {
    imagem: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg',
    nome:'React',
    texto: 'O React é uma biblioteca front-end JavaScript de código aberto com foco em criar interfaces de usuário em páginas web.',
  },

  {
    imagem: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg',
    nome:'Redux',
    texto: 'Redux é uma biblioteca JavaScript de código aberto para gerenciar o estado do aplicativo',
  },

  {
    imagem: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jest/jest-plain.svg',
    nome:'Jest',
    texto: 'Jest é um poderoso Framework de Testes em JavaScript com um foco na simplicidade.',
  },

  {
    imagem: 'https://testing-library.com/img/octopus-128x128.png',
    nome:'RTL',
    texto: 'A React Testing Library é um conjunto de ferramentas voltadas para testar cada um dos componentes React que o desenvolvedor utilizar.',
  },

  {
    imagem: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg',
    nome:'Git',
    texto: 'Git é um sistema de controle de versões distribuído, usado principalmente no desenvolvimento de software, mas pode ser usado para registrar o histórico de edições de qualquer tipo de arquivo.',
  },

  {
    imagem: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg',
    nome:'Github',
    texto: 'GitHub é uma plataforma de hospedagem de código-fonte e arquivos com controle de versão usando o Git.',
  },

  {
    imagem: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg',
    nome:'Docker',
    texto: 'Docker é um conjunto de produtos de plataforma como serviço que usam virtualização de nível de sistema operacional para entregar software em pacotes chamados contêineres. ',
  },

  {
    imagem: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original-wordmark.svg',
    nome:'Node.JS',
    texto: 'Node.js é um software de código aberto, multiplataforma, baseado no interpretador V8 do Google e que permite a execução de códigos JavaScript fora de um navegador web.',
  },

  {
    imagem: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg',
    nome:'Express',
    texto: 'Express.js é um framework para Node.js que fornece recursos mínimos para construção de servidores web.',
  },

  {
    imagem: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-plain.svg',
    nome:'TypeScript',
    texto: 'TypeScript é uma linguagem de programação de código aberto desenvolvida pela Microsoft.',
  },

  {
    imagem: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-plain.svg',
    nome:'MySQL',
    texto: 'O MySQL é um sistema de gerenciamento de banco de dados, que utiliza a linguagem SQL como interface.',
  },

  {
    imagem: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sequelize/sequelize-plain.svg',
    nome:'Sequelize',
    texto: 'O Sequelize é um ORM, ou seja, um mapeador objeto-relacional. Isso significa que ele permite que você crie modelos (classes) em TypeScript ou JavaScript que representam as tabelas do seu banco de dados.',
  },

  {
    imagem: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg',
    nome:'MongoDB',
    texto: 'MongoDB é um software de banco de dados orientado a documentos livre, de código aberto e multiplataforma, escrito na linguagem C++.',
  },

  {
    imagem: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mocha/mocha-plain.svg',
    nome:'Mocha',
    texto: 'O Mocha é uma estrutura de teste JavaScript rica em recursos em execução no Node.js e no navegador, tornando o teste assíncrono simples e divertido.',
  },

  {
    imagem: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kotlin/kotlin-original.svg',
    nome:'Kotlin',
    texto: 'Kotlin é uma linguagem de programação multiplataforma, orientada a objetos e funcional, concisa e estaticamente tipada, desenvolvida pela JetBrains.',
  },

  {
    imagem: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg',
    nome:'Spring',
    texto: 'O Spring é um framework open source para a plataforma Java. Ele é um framework não intrusivo, baseado nos padrões de projeto inversão de controle e injeção de dependência',
  }

]

export default skills;
